import React from 'react';

/**
 * Logo component that displays the Ultimate Bar & Grill logo
 * Uses WebP format with PNG fallback for better performance
 */
const Logo = ({ className = "", width = "200", height = "auto" }) => (
  <div className={`logo-container ${className}`} style={{ width, height }}>
    <picture>
      <source srcSet="/images/logo.webp" type="image/webp" />
      <img
        src="/images/logo.png"
        alt="Ultimate Bar & Grill Logo"
        width={width}
        height={height}
        className="logo-image"
        style={{
          maxWidth: "100%",
          height: "auto",
          objectFit: "contain"
        }}
        onError={(e) => {
          // Fallback to text if image fails to load
          e.target.parentElement.style.display = 'none';
          e.target.parentElement.nextSibling.style.display = 'block';
        }}
      />
    </picture>
    <div
      className="logo-fallback hidden text-yellow-400 font-bold"
      style={{ display: 'none' }}
    >
      <div className="text-lg leading-tight">
        <div>ULTIMATE</div>
        <div>BAR & GRILL</div>
      </div>
    </div>
  </div>
);

export default Logo;
